import axiosInstance from "config/axios-config.js";

// Create academic year
export const createAcademicYear = async (data) => {
  const response = {
    success: false,
    message: "",
    data: null,
  };
  try {
    const res = await axiosInstance.post("/academic-year", data);
    if (res?.data?.success) {
      response.success = res.data.success;
      response.message = res.data?.message ?? "";
      response.data = res.data?.data ?? null;
    } else {
      response.message = res?.data?.message || "Failed to create academic year.";
    }
  } catch (error) {
    response.message =
      error?.response?.data?.message || error?.message || "Failed to create academic year.";
  }
  return response;
};

// Get all academic years (or single by academic_year_id query parameter)
export const getAcademicYear = async (query) => {
  const response = {
    success: false,
    message: "",
    data: null,
  };
  try {
    const res = await axiosInstance.get("/academic-year", { params: query });
    if (res?.data?.success) {
      response.success = res.data.success;
      response.message = res.data?.message ?? "";
      response.data = res.data?.data ?? null;
    } else {
      response.message = res?.data?.message || "Failed to fetch academic year.";
    }
  } catch (error) {
    response.message =
      error?.response?.data?.message || error?.message || "Failed to fetch academic year.";
  }
  return response;
};

// Assign semester to academic year
export const assignSemester = async (data) => {
  const response = {
    success: false,
    message: "",
    data: null,
  };
  try {
    const res = await axiosInstance.post("/academic-year/assign-semester", data);
    if (res?.data?.success) {
      response.success = res.data.success;
      response.message = res.data?.message ?? "";
      response.data = res.data?.data ?? null;
    } else {
      response.message = res?.data?.message || "Failed to assign semester.";
    }
  } catch (error) {
    response.message =
      error?.response?.data?.message || error?.message || "Failed to assign semester.";
  }
  return response;
};

// Get single academic year by ID
export const getAcademicYearByID = async (id) => {
  const response = {
    success: false,
    message: "",
    data: null,
  };
  try {
    const res = await axiosInstance.get(`/academic-year/${id}`);
    if (res?.data?.success) {
      response.success = res.data.success;
      response.message = res.data?.message ?? "";
      response.data = res.data?.data ?? null;
    } else {
      response.message = res?.data?.message || "Failed to fetch academic year.";
    }
  } catch (error) {
    response.message =
      error?.response?.data?.message || error?.message || "Failed to fetch academic year.";
  }
  return response;
};

// Update academic year
export const updateAcademicYear = async (id, data) => {
  const response = {
    success: false,
    message: "",
    data: null,
  };
  try {
    const res = await axiosInstance.put(`/academic-year/${id}`, data);
    if (res?.data?.success) {
      response.success = res.data.success;
      response.message = res.data?.message ?? "";
      response.data = res.data?.data ?? null;
    } else {
      response.message = res?.data?.message || "Failed to update academic year.";
    }
  } catch (error) {
    response.message =
      error?.response?.data?.message || error?.message || "Failed to update academic year.";
  }
  return response;
};

// Delete academic year
export const deleteAcademicYear = async (id) => {
  const response = {
    success: false,
    message: "",
    data: null,
  };
  try {
    const res = await axiosInstance.delete(`/academic-year/${id}`);
    if (res?.data?.success) {
      response.success = res.data.success;
      response.message = res.data?.message ?? "";
      response.data = res.data?.data ?? null;
    } else {
      response.message = res?.data?.message || "Failed to delete academic year.";
    }
  } catch (error) {
    response.message =
      error?.response?.data?.message || error?.message || "Failed to delete academic year.";
  }
  return response;
};
